import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Footer } from "./Footer";
import { useLayoutStore } from "~/store";
import styles from "./TitleBarLayout.module.css";
import { Header } from "./Header";

export const TitleBarLayout = ({ children }) => {
  const {
    showHeader,
    showFooter,
    contentClassName,
    resetLayoutStore,
    completeReset,
  } = useLayoutStore();

  const location = useLocation();
  const prevLocationRef = useRef(location);

  // Reset layout store on each route change
  useEffect(() => {
    const { pathname, search } = prevLocationRef.current;
    const pathnameChanged = location.pathname !== pathname;
    const searchChanged = location.search !== search;

    if (pathnameChanged || searchChanged) {
      prevLocationRef.current = location;
      resetLayoutStore();
      queueMicrotask(() => completeReset());
    }
  }, [location]);

  return (
    <div className={styles.container}>
      {showHeader && <Header />}
      <div className={contentClassName || styles.content}>{children}</div>
      {showFooter && <Footer />}
    </div>
  );
};
